import React from "react";

export const en = {
  body: (
    <div>
      <h3>The Botanical Photogallery</h3>
      The Botanical Photogallery (
      <a href="http://www.botanickafotogalerie.cz/index.php?lng=en">http://www.botanickafotogalerie.cz/</a>) is a
      photographic database of vascular plants and plant communities coordinated by Dana Holubová in
      the Vegetation Science Group. The database contains mainly wild and spontaneously established
      alien species of the Czech Republic. In addition to the normal viewing of photographs, it also
      allows plant identification based on 28 parameters. The gallery contains photographs of the
      whole plants and details of plants organs taken in nature, micro-photographs, scanned images
      and drawings, which often capture important characters important for correct identification.
    </div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>Botanická fotogalerie</h3>
      Botanická fotogalerie (
      <a href="http://www.botanickafotogalerie.cz/">http://www.botanickafotogalerie.cz/</a>) je
      fotografickou databází cévnatých rostlin a rostlinných společenstev, kterou v pracovní skupině
      Výzkum vegetace koordinuje Dana Holubová. Databáze obsahuje především plané a zplanělé druhy
      České republiky. Kromě běžného prohlížení fotografií umožňuje i určování druhů na základě 28
      parametrů. Galerie obsahuje fotografie celkových habitů i detailů rostlin z přírody, řadu
      mikrofotografií, obrázky pořízené pomocí scanneru a kresby, na nichž jsou často zachyceny
      důležité určovací znaky.
    </div>
  )
};
